import React from "react";
import Slider from "slider";
import _HighlightProductByCategoryContainer from "./_HighlightProductByCategoryContainer.scss";
import Product from "components/partials/product";
import {Products, Categories} from "api";
import {Link} from 'react-router-dom';
import moment from 'moment';

class HighlightProductByCategoryContainerOCOOP extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 10,
      order: "id DESC"
    }
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        where: {
          isFeatured: true
        }
      }
    };
    Products.actions.list.request(params).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  render() {
    const settings = {
      className: "slider variable-width product-slick",
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 701,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 1
        }
      }]
    };
    return (
      <section className="product-category-container">
        <div className="center">
          <div className='product-category-wrap'>
            <div className="product-right-content">
              <h3>SẢN PHẨM OCOP QUẢNG NGÃI</h3>
              <Slider {...settings}>
                {
                  this.state.data.map((item, i) => {
                    return (
                      <div key={i}>
                        <Product enableAddProduct={true} {...item}/>
                      </div>
                    );
                  })
                }
              </Slider>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default HighlightProductByCategoryContainerOCOOP;



// WEBPACK FOOTER //
// ./components/home/sub-view/HighlightProductByCategoryContainerOCOOP.jsx